var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"small":"","striped":"","items":_vm.bonusInfoItems,"fields":_vm.bonusInfoFields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }